import Client from "@/http/client";
import {
  CustomerFeedbackDto,
  CustomerFeedbackListDto,
  CustomerFeedbackUnreadCountDto,
} from "@/http/dto/customerFeedback";

export class SupportCustomerFeedback {
  static list(params: any) {
    return Client.get<CustomerFeedbackListDto>("/v2/supporter/feedback", params);
  }

  static detail(objectId: string) {
    return Client.get<CustomerFeedbackDto>(`/v2/supporter/feedback/${objectId}`);
  }

  static unreadCount() {
    return Client.get<CustomerFeedbackUnreadCountDto>("/v2/supporter/feedback/unread-count");
  }

  static reply(objectId: string, contents: string, status = "answered") {
    return Client.post<CustomerFeedbackDto>(`/v2/supporter/feedback/${objectId}/reply`, {
      contents,
      status,
    });
  }

  static changeStatus(objectId: string, status: string) {
    return Client.put<CustomerFeedbackDto>(`/v2/supporter/feedback/${objectId}/status`, { status });
  }
}
